<template>
<!-- 专题页 -->
    <div class="">
        <!-- 头部 -->
        <navbar-header></navbar-header>

        <!-- 海报 -->
        <banner :topImg="topImg"></banner>

        <!-- 专题要闻 -->
        <news-list-row :topList="topList" @update="pageChange"></news-list-row>

        <!-- 列表 -->
        <NewsListColumn :list="list" />

        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import NavbarHeader from "../components/index/NavbarHeader"
    import NavFooter from "../components/common/NavFooter"
    import Banner from "../components/zhuanti/Banner"
    import NewsListRow from "../components/zhuanti/NewsListRow"
    import NewsListColumn from "../components/zhuanti/NewsListColumn"
    export default {
        components: {
            NavbarHeader,
            NavFooter,
            Banner,
            NewsListRow,
            NewsListColumn,
        },
        data() {
            return {
                pageNum: 1,
                totalPage: 1,
                topList: [],
                list: [],
                topImg: "",
            }
        },
        computed: {
            specialReportId() {
                return Number( this.$route.params.id )
            },
            ...mapGetters(['token'])
        },
        created () {
            this.getInfo()
        },
        methods: {
            // 根据iD获取数据
            async getInfo () {
                let { pageNum, specialReportId } = this
                let res = await this.$axios.post("/lencon/pc/news/srDetail", { pageNum, specialReportId })
                if ( res.data.code == 1 ) {
                    this.topList = res.data.topArray
                    this.list = res.data.array
                    this.topImg = res.data.specialReportImg
                    this.totalPage = res.data.totalPage
                }
            },
            // 页码变化
            pageChange ( page ) {
                this.pageNum = page 
                this.getInfo()
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>